import { render, staticRenderFns } from "./DataAtual.vue?vue&type=template&id=b0811ebe&scoped=true"
import script from "./DataAtual.vue?vue&type=script&lang=js"
export * from "./DataAtual.vue?vue&type=script&lang=js"
import style0 from "./DataAtual.vue?vue&type=style&index=0&id=b0811ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0811ebe",
  null
  
)

export default component.exports